import { render } from "./canvasbox.vue?vue&type=template&id=355b0363&scoped=true"
import script from "./canvasbox.vue?vue&type=script&lang=js"
export * from "./canvasbox.vue?vue&type=script&lang=js"

import "./canvasbox.vue?vue&type=style&index=0&id=355b0363&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-355b0363"]])

export default __exports__